/**
 * Flux design tokens — mirrored from fe-nisaba custom-properties.scss
 */
export const fluxColors = {
  primary: {
    lighter: '#dfd1e6',
    light: '#9f79b4',
    main: '#6e3a8f',
    dark: '#552569',
    darker: '#3d174f',
  },
  secondary: {
    lighter: '#ddd0f7',
    light: '#9177e3',
    main: '#7b62de',
    dark: '#634dd9',
    darker: '#4438d3',
  },
  info: {
    lighter: '#d0f2ff',
    light: '#74caff',
    main: '#1890ff',
    dark: '#0c53b7',
    darker: '#04297a',
  },
  success: {
    lighter: '#e9fcd4',
    light: '#aaf27f',
    main: '#54d62c',
    dark: '#229a16',
    darker: '#08660d',
  },
  warning: {
    lighter: '#fff7cd',
    light: '#ffe16a',
    main: '#ffc107',
    dark: '#b78103',
    darker: '#7a4f01',
  },
  error: {
    lighter: '#ffe7d9',
    light: '#ffa48d',
    main: '#ff4842',
    dark: '#b72136',
    darker: '#7a0c2e',
  },
  grey: {
    100: '#f9fafb',
    200: '#f4f6f8',
    300: '#dfe3e8',
    400: '#c4cdd5',
    500: '#919eab',
    600: '#637381',
    700: '#454f5b',
    800: '#212b36',
    900: '#161c24',
  },
  white: '#ffffff',
  black: '#000000',
  paperDark: '#171f27',
} as const;

export const fluxGradients = {
  primary: 'linear-gradient(135deg, #9f79b4 0%, #522569 100%)',
  brandLight:
    'linear-gradient(135deg, #f0edf5 0%, #e8e2f0 25%, #ddd4e8 50%, #d4c7de 75%, #cbbdd4 100%)',
  brandDark:
    'linear-gradient(135deg, #474258 0%, #524d65 25%, #5d5873 50%, #696280 75%, #756e8d 100%)',
} as const;

export const fluxFontFamily =
  "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Helvetica, Arial, sans-serif";
